module.exports = __webpack_public_path__ + "static/media/bubble.f24ecd51.jpg";